import {multiplySize}   from "./multiply-size";
import {multiplyVector} from "./multiply-vector";

export const multiplyRect = (r, ratio) => ({
    ...multiplyVector(r, ratio),
    ...multiplySize(r, ratio),
});
